import { render, staticRenderFns } from "./RelatorioComercialOSView.vue?vue&type=template&id=7f8e9972&scoped=true"
import script from "./RelatorioComercialOSView.vue?vue&type=script&lang=js"
export * from "./RelatorioComercialOSView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioComercialOSView.vue?vue&type=style&index=0&id=7f8e9972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8e9972",
  null
  
)

export default component.exports